import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

// 模拟导航数据
const categories = [
  {
    id: 'tools',
    name: '常用工具',
    links: [
      {
        id: 1,
        title: 'ChatGPT',
        url: 'https://chat.openai.com',
        description: 'OpenAI开发的AI聊天助手'
      },
      {
        id: 2,
        title: 'GitHub',
        url: 'https://github.com',
        description: '全球最大的代码托管平台'
      }
    ]
  },
  {
    id: 'ai',
    name: 'AI工具',
    links: [
      {
        id: 3,
        title: 'Midjourney',
        url: 'https://www.midjourney.com',
        description: 'AI图像生成工具'
      },
      {
        id: 4,
        title: 'Claude',
        url: 'https://claude.ai',
        description: 'Anthropic开发的AI助手'
      }
    ]
  }
];

export default function Navigation() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800">
      {/* 顶部导航 */}
      <nav className="bg-gray-800/50 shadow-lg">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Compass className="w-8 h-8 text-blue-500" />
              <span className="text-xl font-bold text-white">一雄导航</span>
            </Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-300 hover:text-white">
                登录
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* 主要内容 */}
      <main className="container mx-auto px-4 py-8">
        <div className="space-y-12">
          {categories.map(category => (
            <section key={category.id}>
              <h2 className="text-2xl font-bold text-white mb-6">
                {category.name}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.links.map(link => (
                  <a
                    key={link.id}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-6 bg-gray-800/50 rounded-lg hover:bg-gray-800/70 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-white mb-2">
                      {link.title}
                    </h3>
                    <p className="text-gray-400">
                      {link.description}
                    </p>
                  </a>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

      {/* 页脚 */}
      <footer className="bg-gray-800/50 mt-12">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center text-gray-400">
            <p>© {new Date().getFullYear()} 一雄导航. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}